import { cover } from "polished";
import styled, { css } from "styled-components";
import { touchTargetSizeSpace } from "../../../settings";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import getIconColor from "../../../utils/getIconColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import Button from "../../quarks/Button";
var StyledIconButtonAtm = styled(Button).withConfig({
  componentId: "sc-q0mgkn-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    $emphasis = _ref.$emphasis,
    $hasText = _ref.$hasText,
    $iconSize = _ref.$iconSize,
    $hasTextToRight = _ref.$hasTextToRight,
    $backgroundColor = _ref.$backgroundColor,
    $hasBorder = _ref.$hasBorder,
    $borderColor = _ref.$borderColor,
    $borderRadius = _ref.$borderRadius,
    $paddingSpace = _ref.$paddingSpace,
    $hasShadowOnHover = _ref.$hasShadowOnHover,
    $hasDisabledTouchTargetSpace = _ref.$hasDisabledTouchTargetSpace,
    theme = _ref.theme;
  return css(["display:inline-flex;position:relative;min-width:", ";min-height:", ";", " ", " ", " ", " ", " ", " ", ""], space($iconSize), space($iconSize), !$hasDisabledTouchTargetSpace ? css(["&::after{", ";content:\"\";top:50%;left:50%;width:", ";height:", ";transform:translate(-50%,-50%);}"], cover(), space(touchTargetSizeSpace), space(touchTargetSizeSpace)) : null, $backgroundColor ? css(["background-color:", ";"], getColor(theme, $backgroundColor)) : null, $hasBorder ? css(["border:", " solid ", ";"], unit(1), $borderColor ? getColor(theme, $borderColor) : getBorderColor(theme, $onColor, "extraLow")) : null, $paddingSpace ? css(["padding:", ";"], space($paddingSpace)) : null, $hasShadowOnHover ? css(["&:hover{box-shadow:", ";}"], getBoxShadow(theme, "nano")) : css(["&:hover *{fill:", ";}"], getIconColor(theme, $onColor, $emphasis, "hover")), $borderRadius ? css(["border-radius:", ";"], getBorderRadius(theme, $borderRadius)) : null, $hasText && css(["flex-direction:", ";align-items:center;gap:", ";svg{flex-shrink:0;}"], $hasTextToRight ? "row" : "column", $hasTextToRight ? space(1) : 0));
});
export default StyledIconButtonAtm;